import { createContext, useContext } from 'react';

const ShowHelpAnnotationsContext = createContext(false);

/**
 * This is used to generate images for our help desk articles. The generation
 * is done as part of our E2E tests.
 */
export function useShowHelpAnnotations() {
  return useContext(ShowHelpAnnotationsContext);
}

export const ShowHelpAnnotationsProvider = ShowHelpAnnotationsContext.Provider;
